import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonDataService } from '@app/services/common-data/common-data.service';
import { PortalSalesAgentNode } from '@app/services/api/api.types';

@Component({
  selector: 'need-help-card',
  templateUrl: './need-help-card.component.html',
  styleUrl: './need-help-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NeedHelpCardComponent {
  @Input() salesAgent?: PortalSalesAgentNode;

  protected commonDataService = inject(CommonDataService);
}
